import styled, { css } from 'styled-components'
import { colors } from '@blocket/blocket-ui'

const StyledFooterMenu = css`
  &.footer-menu {
    .menu-content {
      max-width: 980px;
      margin: 0 auto;
      display: grid;
      display: -ms-grid;
      -ms-grid-columns: 1fr 1fr 1fr 1fr;
      grid-template-columns: repeat(2, 1fr);
      column-gap: 16px;
      row-gap: 16px;
    }

    @media (min-width: 768px) {
      .menu-content {
        grid-template-columns: repeat(4, 1fr);
      }
    }
  }
`

const StyledMenu = styled.div`
  .menu-section {
    :nth-child(1) {
      -ms-grid-column: 1;
    }
    :nth-child(2) {
      -ms-grid-column: 2;
    }
    :nth-child(3) {
      -ms-grid-column: 3;
    }
    :nth-child(4) {
      -ms-grid-column: 4;
    }
  }
  .menu-section {
    &__title-link {
      font-family: 'BlocketSans-Medium', sans-serif;
      font-size: 17px;
      line-height: 1.29;
      color: ${colors.grey800};
      margin-bottom: 8px;
      justify-content: space-between;
      display: flex;
      align-items: center;
    }

    &__content {
      background: ${colors.white100};
    }

    &__list-item {
      margin-bottom: 8px;
    }

    &__list-item-link {
      font-family: 'BlocketSans-Regular', sans-serif;
      font-size: 15px;
      color: ${colors.grey700};
    }
  }

  ${StyledFooterMenu}
`

export default StyledMenu
